export const OfficeFluidContainerPackageName = '@ms/office-fluid-container';
export const OneNoteMeetingPackageName = '@ms/onenote-meetings';
export const Ch5ContainerPackageName = '@fluidx/ch5-container';
export const CatalogContainerPackageName = '@fluidx/catalog-container';
